import React, { useContext } from 'react'
import "./UpdateBody.css"
import { storageData } from 'services/Services'

const UpdateBody = ({ requestContext, endorsementType }) => {
    const vehicleContext = useContext(requestContext)
    var response = storageData.getItem("responseData")
    response = JSON.parse(response)

    const downloadPdf = (pdfBytes, fileName) => {
        const pdf = `data:application/octet-stream;base64,${pdfBytes}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = pdf;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    return (
        <div className='container'>
            {/* Requested Effective Date */}
            <div className='row justify-content-center mb-3'>
                <div className='col-12 text-center'>
                    <p className='fw-bold m-0'>
                        Change Requested Effective Date:
                        <span className='ms-1 text-primary'>
                            {response?.effectiveDate}
                        </span>
                    </p>
                </div>
            </div>

            {/* Vehicle */}
            <div className='row justify-content-center my-3'>
                <div className='col-12 text-center'>
                    <p className='fw-bold m-0'>
                        The following change(s) has been processed:
                    </p>
                    {endorsementType == "Add Vehicle" &&
                        <span className='ms-1 text-primary fw-bold'>
                            {`${response?.vehicles[0]?.VehicleYear} ${response?.vehicles[0]?.VehicleMake} ${response?.vehicles[0]?.VehicleModel} ${response?.vehicles[0]?.VehicleVIN} - New Vehicle`}
                        </span>
                    }
                    {endorsementType == "Remove Vehicle" &&
                        <span className='ms-1 text-primary fw-bold'>
                            {`${response?.vehicles[0]?.VehicleYear} ${response?.vehicles[0]?.VehicleMake} ${response?.vehicles[0]?.VehicleModel} ${response?.vehicles[0]?.VehicleVIN} - Removed Vehicle`}
                        </span>
                    }
                    {endorsementType == "Replace Vehicle" &&
                        <>
                            <span className='ms-1 text-primary fw-bold'>
                                {`${response?.vehicles[0]?.VehicleYear} ${response?.vehicles[0]?.VehicleMake} ${response?.vehicles[0]?.VehicleModel} ${response?.vehicles[0]?.VehicleVIN} - New Vehicle`}
                            </span>
                            <br />
                            <span className='ms-1 text-primary fw-bold'>
                                {`${response?.vehicles[1]?.VehicleYear} ${response?.vehicles[1]?.VehicleMake} ${response?.vehicles[1]?.VehicleModel} ${response?.vehicles[1]?.VehicleVIN} - Removed Vehicle`}
                            </span>
                        </>
                    }
                </div>
            </div>

            {/* Download ID Card and Dec Page */}
            <div className='row justify-content-center my-3'>
                <div className='col-12 text-center'>
                    <p className='fw-bold m-0'>
                        Download your new ID card(s) and declarations page below.
                    </p>
                    <span className='ms-1 text-primary fw-bold text-decoration-underline'>
                        <a onClick={() => downloadPdf(response?.idCardPdfBytes, `${vehicleContext.userData?.policyNumber} - ID Card.pdf`)}>
                            ID Card
                        </a>
                    </span>
                    <br />
                    <span className='ms-1 text-primary fw-bold text-decoration-underline'>
                        <a onClick={() => downloadPdf(response?.declarationsPagePdfBytes, `${vehicleContext.userData?.policyNumber} - Declarations Page.pdf`)}>
                            Declarations Page
                        </a>
                    </span>
                </div>
            </div>

            <div className='row justify-content-center my-4'>
                <div className='col-12 text-center'>
                    <p className='fw-bold m-0'>
                        You’ll receive an email in the next 1 to 2 hours with a confirmation of your policy update and a breakdown of your new 6-month term cost.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default UpdateBody